module.exports = __webpack_public_path__ + "img/timer.2a3fc951.svg";